import {
  ClusterGroup,
  ClusterMarkerMeta,
  ClusterStatus,
  DenmClusterStatus,
  IvimClusterStatus,
  PmvClusterStatus,
  RsuClusterStatus,
  SpatemClusterStatus,
} from './types';

const META_PREFIX = 'emeras';

const GROUPS: ReadonlySet<string> = new Set(['rsu', 'pmv', 'spatem', 'denm', 'ivim']);

export function encodeClusterMeta(meta: ClusterMarkerMeta): string {
  return `${META_PREFIX}:${meta.group}:${meta.status}`;
}

export function decodeClusterMeta(raw: string | undefined | null): ClusterMarkerMeta | null {
  if (!raw) {
    return null;
  }
  const parts = raw.split(':');
  if (parts.length !== 3 || parts[0] !== META_PREFIX) {
    return null;
  }
  const [, group, status] = parts;
  if (!GROUPS.has(group) || !status) {
    return null;
  }
  return { group: group as ClusterGroup, status: status as ClusterStatus };
}

export function rsuClusterStatus(alive: boolean, status?: string | null): RsuClusterStatus {
  if (!alive) {
    return 'unknown';
  }
  switch (status) {
    case 'up':
    case 'warning':
    case 'error':
    case 'down':
    case 'agg':
    case 'unknown':
      return status;
    default:
      return 'unknown';
  }
}

export function pmvClusterStatus(working: boolean): PmvClusterStatus {
  return working ? 'working' : 'not-working';
}

export function spatemClusterStatus(active: boolean): SpatemClusterStatus {
  return active ? 'active' : 'inactive';
}

export function denmClusterStatus(isActive: boolean, disabled: boolean): DenmClusterStatus {
  if (disabled) {
    return 'disabled';
  }
  return isActive ? 'progress' : 'terminated';
}

export function ivimClusterStatus(
  isActive: boolean,
  disabled: boolean,
  scheduled: boolean,
): IvimClusterStatus {
  if (scheduled) {
    return 'scheduled';
  }
  if (disabled) {
    return 'disabled';
  }
  return isActive ? 'progress' : 'terminated';
}
